import React from 'react'
import * as R from 'ramda'
import { t } from 'ttag'

import { Box } from 'components/layout/Box/Box'
import { Button } from 'components/shared/Button/Button'
import { Form } from 'components/shared/Form/Form'
import { DeleteButton } from 'components/modules/creators/TemplatesCreator/tabs/Interviews/common/ActionButtons/DeleteButton/DeleteButton'

import {
  DESCRIPTION_FIELD,
  QUESTIONS_GROUP_FIELD,
  QUESTION_FIELD,
  QUESTION_STATUSES,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/model'

import { PlusCircleIcon } from 'components/shared/Icon/model'

import styles from './QuestionFieldsGroup.module.scss'

export const QuestionFieldsGroup = ({
  control,
  fields,
  formState,
  onDeleteQuestionOpen,
  onInsertQuestion,
  hasNoQuestions,
}) => (
  <Box align="center" className={styles.group} direction="column">
    {R.pipe(
      R.filter(({ status }) => !R.equals(status, QUESTION_STATUSES.DELETED)),
      R.addIndex(R.map)((item, index) => {
        const counter = R.add(index, 1)

        const originalIndex = R.findIndex(
          ({ id }) => R.equals(id, item?.id),
          fields,
        )

        return (
          <Box className={styles.fields} direction="column" key={item.id}>
            <Box className={styles.row} align="flex-end">
              <Form.Field
                error={
                  formState.errors[QUESTIONS_GROUP_FIELD]?.[originalIndex]?.[
                    QUESTION_FIELD
                  ]?.message
                }
                field="input"
                label={t`Question ${counter}`}
                name={`${QUESTIONS_GROUP_FIELD}[${originalIndex}].${QUESTION_FIELD}`}
                placeholder={t`Write the interview question here`}
                {...{ control }}
              />
              <DeleteButton
                ariaLabel="delete"
                className={styles.button}
                onClick={() =>
                  onDeleteQuestionOpen({ item, index: originalIndex })
                }
                isDisabled={hasNoQuestions}
              />
            </Box>
            <Form.Field
              className={styles.field}
              error={
                formState.errors[QUESTIONS_GROUP_FIELD]?.[originalIndex]?.[
                  DESCRIPTION_FIELD
                ]?.message
              }
              field="textarea"
              label={t`Description ${counter}`}
              name={`${QUESTIONS_GROUP_FIELD}[${originalIndex}].${DESCRIPTION_FIELD}`}
              placeholder={t`Describe the question or write some in depth questions`}
              isOptional
              {...{ control }}
            />
          </Box>
        )
      }),
    )(fields)}
    <Button
      className={styles.button}
      icon={PlusCircleIcon}
      label={t`Question`}
      size="small"
      variant="filled"
      onClick={onInsertQuestion}
      isFullWidth
    />
  </Box>
)
